<template>
    <div class="photos-modal relative group/photos">

        <Splide class="relative" :has-track="false" :options="{ rewind: true, speed: 650, easing: 'cubic-bezier(0.45, 0, 0.55, 1)', autoplay: true, pauseOnHover: true, pauseOnFocus: true, interval: 4000, pagination: false }" aria-label="My Favorite Images" v-if="item && item.photo_set" @splide:move="toggleCaption">

            <SplideTrack>
                <SplideSlide v-for="photo in item.photo_set" :key="photo">
                    <div class="photo-slide relative w-full aspect-[16/10]">
                        <img :src="photo.large" class="w-full h-full object-cover" />

                        <div class="photo-caption-wrapper absolute bottom-0 w-full left-0 p-2.5" v-if="photo.caption">
                            <div class="photo-caption w-full bg-gray-900 bg-opacity-70 font-medium antialiased py-2.5 px-3 text-sm text-white drop-shadow transition-all duration-500 ease-out translate-y-full group-hover/photos:translate-y-0 scale-75 group-hover/photos:scale-100 opacity-0 group-hover/photos:opacity-100 border-l border-l-[5px] border-l-sky-400 rounded-md">
                                <div v-html="photo.caption"></div>
                            </div>
                        </div>
                    </div>
                </SplideSlide>

                <SplideSlide v-if="item.related_links && item.related_links.length > 0">
                  <div class="related-slide w-full aspect-[16/10] relative">
                    <img :src="item.photo_set[0].large" class="w-full h-full object-cover" />

                    <div class="related-links absolute w-full h-full flex bg-black bg-opacity-75 items-center justify-center flex-col text-white top-0 left-0">
                      <h3 class="text-xl font-medium antialiased text-sky-300 mb-3">Related Links</h3>
                      <div class="link-list flex flex-col items-center gap-2">

                        <a class="py-0.5 hover:text-sky-300" :href="link.link.url" :target="link.link.target" v-html="link.title" v-for="(link, ldx) in item.related_links" :key="ldx"></a>
                      </div>
                    </div>
                  </div>
                </SplideSlide>
            </SplideTrack>

            <div class="splide__arrows z-20 absolute pointer-events-none w-full top-1/2 left-0 -translate-y-1/2 flex justify-between px-1.5 opacity-0 scale-110 transition-all ease-out duration-300 group-hover/photos:scale-100 group-hover/photos:opacity-100">
                <button class="splide__arrow splide__arrow--prev pointer-events-auto text-white flex w-10 h-10 flex items-center justify-center opacity-70 transition-opacity duration-500 hover:opacity-100">
                    <svg class="w-8 h-8" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M31 36L19 24L31 12" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                </button>
                <button class="splide__arrow splide__arrow--next pointer-events-auto text-white flex w-10 h-10 flex items-center justify-center opacity-70 transition-opacity duration-500 hover:opacity-100">
                    <svg class="w-8 h-8" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12L31 24L19 36" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

        </Splide>

    </div>
</template>
<script setup>

    import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { ref } from 'vue';


    const props = defineProps({
        item: {
            type: Object,
            default: null
        }
    })

    const showCaption = ref(true)

    const toggleCaption = () => {
        showCaption.value = false
        setTimeout(() => {
            showCaption.value = true
        }, 600)
    }
</script>
